import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import l10n from "../../../lang/locallang";

const sortingSection = (param, is_public = false) => {
    const { enterQuestion, addNewItem, item } = l10n.editor;
    param.class = param.class ? param.class : 'editor-section';
    param.content = param.content ? param.content : ``;
    param.style = param.style ? param.style : '';
    param.layout = param.layout ? param.layout : 'sortingLayout';
    param.section = 'sortingSection';
    param.component = `
            <div class="matching-activity">
                <div class="matching-activity-question">
                    <span contenteditable="true" placeholder="Enter question">${enterQuestion}</span>
                </div>
                <div class="sequence-list-wrapper">
                    <ul class="sequence-list">
                        <li draggable="true" class="sequence-item" data-sequence-id="1"><span contenteditable="true">${item} 1</span></li>
                        <li draggable="true" class="sequence-item" data-sequence-id="2"><span contenteditable="true">${item} 2</span></li>
                        <li draggable="true" class="sequence-item" data-sequence-id="3"><span contenteditable="true">${item} 3</span></li>
                        <li draggable="true" class="sequence-item" data-sequence-id="4"><span contenteditable="true">${item} 4</span></li>
                    </ul>
                </div>
                <div class="add-e-element-btn-wr">
                    <button class="btn add-e-element-btn"><i class="icon icon-add"></i><span>${addNewItem}</span></button>
                </div>
            </div>`;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {sortingSection};
